module.exports = __webpack_public_path__ + "media/images/landing/ar/create-06d33505108d8557698950bb8c856ed5.png";